import React from 'react';
import { useIncrementalRendering } from '@/hooks';
import { groupRowsIntoCellChunks } from '@/features/drilldown/utils';
import { DrilldownRow } from './DrilldownRow';

const useExpandedIndexes = () => {
  const [expandedRowsIndexes, setExpandedRowsIndexes] = React.useState<
    number[]
  >([]);

  const toggleExpandedRowsIndexes = React.useCallback(
    (rowIndex: number) => {
      if (expandedRowsIndexes.includes(rowIndex)) {
        setExpandedRowsIndexes((is) => is.filter((i) => i !== rowIndex));
      } else {
        setExpandedRowsIndexes((is) => [...is, rowIndex]);
      }
    },
    [expandedRowsIndexes],
  );

  return [expandedRowsIndexes, toggleExpandedRowsIndexes] as const;
};

export const DrilldownRowsRenderer: React.FC<any> = ({ dataTable }) => {
  const [expandedRowsIndexes, handleDrilldown] = useExpandedIndexes();
  const [rows, setRows] = React.useState(
    groupRowsIntoCellChunks(dataTable, expandedRowsIndexes),
  );

  React.useEffect(() => {
    setRows(groupRowsIntoCellChunks(dataTable, expandedRowsIndexes));
  }, [dataTable, expandedRowsIndexes]);

  const toRender = useIncrementalRendering(rows.length, 2, 100);

  return (
    <>
      {rows.slice(0, toRender).map((row: any, index: number) => (
        <DrilldownRow
          key={index}
          rowIndex={index}
          dataTable={dataTable}
          cellChunksForRow={row}
          onDrilldown={handleDrilldown}
          isHeaderShown={index !== rows.length - 1}
        />
      ))}
    </>
  );
};
